import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface PillProps {
  icon?: LucideIcon;
  children: ReactNode;
  /** Achtergrond (+ evt. tekstkleur), bijv. `MAIN_CATEGORY_THEMES[cat].pillBg`. */
  className?: string;
  title?: string;
}

/** Niet-interactief informatielabel: [Icoon + Tekst], altijd op één regel. */
export function Pill({ icon: Icon, children, className = 'bg-black/5 dark:bg-white/10', title }: PillProps) {
  return (
    <span
      title={title}
      className={`inline-flex h-7 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 text-xs font-semibold ${className}`}
    >
      {Icon ? <Icon size={14} strokeWidth={2.2} aria-hidden="true" className="shrink-0" /> : null}
      {children}
    </span>
  );
}
